//API ref
export const GET_API_REF = 'GET_API_REF';
//Banner
export const GET_LIST_BANNER_REQUEST = 'GET_LIST_BANNER_REQUEST';
export const GET_LIST_BANNER_SUCCESS = 'GET_LIST_BANNER_SUCCESS';
export const GET_LIST_BANNER_FAILURE = 'GET_LIST_BANNER_FAILURE';

//Categories
export const GET_LIST_CATEGORIES_REQUEST = 'GET_LIST_CATEGORIES_REQUEST';
export const GET_LIST_CATEGORIES_SUCCESS = 'GET_LIST_CATEGORIES_SUCCESS';
export const GET_LIST_CATEGORIES_FAILURE = 'GET_LIST_CATEGORIES_FAILURE';

export const CHANGE_SELECTED_CATEGORY = 'CHANGE_SELECTED_CATEGORY';

//Products
export const GET_LIST_PRODUCTS_REQUEST = 'GET_LIST_PRODUCTS_REQUEST';
export const GET_LIST_PRODUCTS_SUCCESS = 'GET_LIST_PRODUCTS_SUCCESS';
export const GET_LIST_PRODUCTS_FAILURE = 'GET_LIST_PRODUCTS_FAILURE';

//Pagination Categories
export const CHANGE_CATEGORIES_PAGE = 'CHANGE_CATEGORIES_PAGE';

//Product Detail
export const GET_PRODUCT_DETAIL_REQUEST = 'GET_PRODUCT_DETAIL_REQUEST';
export const GET_PRODUCT_DETAIL_SUCCESS = 'GET_PRODUCT_DETAIL_SUCCESS';
export const GET_PRODUCT_DETAIL_FAILURE = 'GET_PRODUCT_DETAIL_FAILURE';

//Search Bar
export const CHANGE_SEARCH_VALUE = 'CHANGE_SEARCH_VALUE';

export const GET_PRODUCT_SEARCH_REQUEST = 'GET_PRODUCT_SEARCH_REQUEST';
export const GET_PRODUCT_SEARCH_SUCCESS = 'GET_PRODUCT_SEARCH_SUCCESS';
export const GET_PRODUCT_SEARCH_FAILURE = 'GET_PRODUCT_SEARCH_FAILURE';

//Shopping Cart
export const GET_SHOPPING_CART_REQUEST = 'GET_SHOPPING_CART_REQUEST';
export const GET_SHOPPING_CART_SUCCESS = 'GET_SHOPPING_CART_SUCCESS';
export const GET_SHOPPING_CART_FAILURE = 'GET_SHOPPING_CART_FAILURE';

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';

export const EDIT_SHOPPING_CART_REQUEST = 'EDIT_SHOPPING_CART_REQUEST';
export const EDIT_SHOPPING_CART_SUCCESS = 'EDIT_SHOPPING_CART_SUCCESS';
export const EDIT_SHOPPING_CART_FAILURE = 'EDIT_SHOPPING_CART_FAILURE';

export const REMOVE_PRODUCT_CART_REQUEST = 'REMOVE_PRODUCT_CART_REQUEST';
export const REMOVE_PRODUCT_CART_SUCCESS = 'REMOVE_PRODUCT_CART_SUCCESS';
export const REMOVE_PRODUCT_CART_FAILURE = 'REMOVE_PRODUCT_CART_FAILURE';

export const CHANGE_STOCK_ON_CART_REQUEST = 'CHANGE_STOCK_ON_CART_REQUEST';
export const CHANGE_STOCK_ON_CART_SUCCESS = 'CHANGE_STOCK_ON_CART_SUCCESS';
export const CHANGE_STOCK_ON_CART_FAILURE = 'CHANGE_STOCK_ON_CART_FAILURE';
